module.exports = __webpack_public_path__ + "img/completed-circle.edb15b81.svg";